// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"127":"default-list","982":"default-drawer-header"}[chunkId] || chunkId) + "." + {"127":"dd6daf94","256":"271fae26","533":"5f18022b","764":"7d4c3278","788":"0ff5c872","982":"09dab711"}[chunkId] + ".js";
};